import { createEffect, createSignal } from "solid-js"
import isEntityWater from "../../lib/core/entity/isEntityWater"
import isFloatArraySame from "../signal/equals/isFloatArraySame"
import createSharedCachedFactory from "./createSharedCachedFactory"
import { createSharedTileGraphNodeCollectionMemo } from "./createSharedTileGraphNodeCollectionMemo"
import { useSharedManhattanDistanceToLandListMemo } from "./useSharedManhattanDistanceToLandListMemo"
import { useSharedTerrainBaseFloorElevationListMemo } from "./useSharedTerrainBaseFloorElevationListMemo"

export const useSharedTerrainDerivedFloorElevationListMemo = createSharedCachedFactory((engine) => {
  const getTileGraphNodesList = createSharedTileGraphNodeCollectionMemo(engine)
  const getBaseElevationList = useSharedTerrainBaseFloorElevationListMemo(engine)
  const getDistanceToLandList = useSharedManhattanDistanceToLandListMemo(engine)

  const [getDerivedElevationList, setDerivedElevationList] = createSignal<Float32Array>(new Float32Array(), {
    equals: isFloatArraySame,
  })

  // createEffect(() => {
  //   getDerivedElevationList()
  //   console.log('getDerivedElevationList')
  // })
  // createEffect(() => {
  //   getBaseElevationList()
  //   console.log('getBaseElevationList')
  // })
  // createEffect(() => {
  //   getDistanceToLandList()
  //   console.log('getDistanceToLandList')
  // })

  createEffect(() => {
    const tpNodeList = getTileGraphNodesList()
    createEffect(() => {
      const dList = new Float32Array(tpNodeList.length)
      const baseElevationList = getBaseElevationList()
      const distanceToLandList = getDistanceToLandList()
      for (let i = 0; i < tpNodeList.length; i++) {
        const tpNode = tpNodeList[i]
        const baseElevation = baseElevationList[i]
        const elevation = baseElevation
        const distanceToLand = distanceToLandList[i]

        // Only reduce elevation for water-based terrain types
        // Land-based terrain (Desert, Plain, Snow, etc.) should maintain their base elevation
        if (distanceToLand > 0 && tpNode.ents().find(isEntityWater)) {
          dList[i] = elevation - ((distanceToLand - 1) / 2)
        } else {
          dList[i] = elevation
        }

        // if (distanceToLand > 0) {
        //   dList[i] = elevation - ((distanceToLand - 1) / 2)
        // } else {
        //   dList[i] = elevation
        // }

      }
      setDerivedElevationList(dList)
    })
  })

  // createEffect(() => {
  //   console.log('getDerivedElevationList.effect.value', getDerivedElevationList())
  // })

  return getDerivedElevationList
})